var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "files" },
    [
      _vm._l(_vm.filteredFiles, function(file) {
        return [
          _vm.listStyle === "pill"
            ? _c("li", { staticClass: "pill mr-2 mb-1" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "btn py-4px px-12px t-navy fs-14 lh-lg bg-grey border-radius-sm",
                    attrs: { href: file.aws_url }
                  },
                  [_vm._v(_vm._s(file.filename))]
                )
              ])
            : _c(
                "li",
                { staticClass: "file row bg-white px-3 py-12px t-navy w-100" },
                [
                  _c("div", { staticClass: "column p-0 file__name py-12px" }, [
                    _vm._v(_vm._s(file.filename))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "column p-0 pl-sm-2 file__date font-weight-light"
                    },
                    [_vm._v(_vm._s(_vm.formattedDate(file.created_at)))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column p-0 file__btn text-sm-right" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-ghost bg-white",
                          attrs: { href: file.aws_url, target: "_blank" }
                        },
                        [_vm._v("View")]
                      )
                    ]
                  )
                ]
              )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d8d7949", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d8d7949","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/FileList.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2d8d7949","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/FileList.vue
// module chunks = 0 1